<template>
  <div class="dashboard full" :style="colstyle">
    <a href="https://simsales.ru/about" target="_blank" class="logo">
      <img src="../assets/logo.svg" alt="" />
    </a>
    <h3 class="table-title">
      Темп звонков<br />
      <span>норма звонков: {{ norma.calls }}</span>
    </h3>
    <h3 class="table-title">
      Темп минут<br />
      <span>норма минут: {{ norma.minutes }}</span>
    </h3>

    <template v-for="(column, index) in columns">
      <h3
        :key="column._id + index"
        class="table-title"
        v-if="column.type === 'counter'"
      >{{ column.name.split(' ')[0] }}<br />
        <span>{{
          column.name
            .split(' ')
            .slice(1)
            .join(' ')
        }}</span>
      </h3>
    </template>

    <template v-for="(column, index) in columns">
      <h2
        class="proceeds"
        :key="column._id + index"
        v-if="column.type === 'sum'"
      >{{ column.name }}
      </h2>
    </template>

    <template v-for="(user) in users">
      <h3
        v-bind:key="user.id"
        :class="'username big ' + (user.leader ? 'bold ' : '')"
        :style="{ fontSize: lineHeight ? lineHeight / 4.9 + 'px' : '28px' }"
      >{{ user.name.replace(/ /g, '\n') }}
      </h3>
      <!--
      cl - должен быть уникален (иначе id в svg получаются одинаковыми и всё ломается
      name - нужно отдать массив из трёх склонений. Проверить так:
        1) 1 ЗВОНОК/МИНУТА
        2) 4 ЗВОНКА/МИНУТЫ
        3) Несколько ЗВОНКОВ/МИНУТ
    -->
      <chart
        :key="user.id + '2'"
        :cl="'call' + user.id"
        :percent="user.callPercent"
        :data="user.calls"
        :name="['звонок', 'звонка', 'звонков']"
        :height="lineHeight"
      ></chart>
      <chart
        :key="user.id + '3'"
        :cl="'minutes' + user.id"
        :percent="user.minutePercent"
        :data="user.minutes"
        :name="['минута', 'минуты', 'минут']"
        :height="lineHeight"
      ></chart>
      <!--Круги до 6 цифр-->
      <template v-for="(column, index) in columns">
        <div
          v-if="column.type === 'counter'"
          v-bind:key="user.id + '_' + index"
          :class="column.type === 'counter' ? 'round-info' : 'big-number'"
          :style="
            column.type === 'counter'
              ? roundInfoFontSize(user.columns[column._id])
              : { fontSize: lineHeight ? lineHeight / 3.2 + 'px' : '43px' }
          "
        >
          {{
            column.type === 'counter'
              ? user.columns[column._id]
              : user.columns[column._id].toLocaleString('ru')
          }}
        </div>
      </template>
      <template v-for="(column, index) in columns">
        <div
          v-if="column.type === 'sum'"
          v-bind:key="user.id + '_' + index"
          :class="column.type === 'counter' ? 'round-info' : 'big-number'"
          :style="
            column.type === 'counter'
              ? roundInfoFontSize(user.columns[column._id])
              : { fontSize: lineHeight ? lineHeight / 3.2 + 'px' : '43px' }
          "
        >
          {{
            column.type === 'counter'
              ? user.columns[column._id]
              : user.columns[column._id].toLocaleString('ru')
          }}
        </div>
      </template>

      <!--
      Чтобы добавить кружок, нужно скопировать следующую строку, добавить в неё переменную и не повторяющийся :key
      Кол-во .table-title должно быть равно спидометрам + кружкам (иначе всё поедет)
      -->
    </template>
  </div>
</template>

<script>
import chart from './chart';
import moment from 'moment-timezone';
import bent from 'bent';
import _ from 'lodash';
import * as R from 'ramda'

export default {
  name: 'tempDashboard',
  components: { chart },
  props: ['panelId', 'password', 'baseUrl'],
  data() {
    return {
      post: {},
      interval: null,
      columns: [],
      calls: [],
      callsSettings: {},
      zoomSettings: {},
      data: [],
      lineHeight: 120,
      gap: {},
      users: [
        //Стандартный json пользователя
        /*  {
          id: 1,
          name: 'Дмитрий Стареньков',
          callPercent: 75, // Проценты нужно на бэке проверить, чтобы меньше 0 и больше 100 небыло
          call: 25,
          minutePercent: 35,
          minute: 12,
          meetings: 2,
          invoices: 23,
          profit: 123214,
        }, */
      ],
      subdomain: '',
      limit: 0,
      offset: 0,
      settings: {},
      norma: {
        calls: 0,
        minutes: 0,
      },
    };
  },
  methods: {
    findUserCalls(user) {
      for (let call in this.calls) {
        // this.logger.info({mgr: mgr.id, call})
        if (user.id == call) {
          // this.logger.info({call: calls[call]})
          return {
            calls: this.calls[call].total.calls_count,
            minutes: parseInt(this.calls[call].total.calls_time / 60),
          };
        }
      }
      return {
        calls: 0,
        minutes: 0,
      };
    },
    async calculateNorma() {
      this.norma = {
        calls: parseInt(this.expectedCalls),
        minutes: parseInt(this.expectedMinutes),
      };
    },
    roundInfoFontSize(string) {
      let a = String(string).length;
      let fs = 43;
      if (a <= 3) {
        fs = 43;
      } else if (a === 4) {
        fs = 35;
      } else if (a === 5) {
        fs = 24;
      } else if (a === 6) {
        fs = 20;
      } else {
        fs = 16;
      }
      fs = (fs * this.lineHeight) / 138;
      let borderWidth = 5;
      let lh = this.lineHeight - 10;
      if (this.lineHeight < 100) {
        borderWidth = 3;
        lh = this.lineHeight - 6;
      }

      return {
        fontSize: fs + 'px',
        height: this.lineHeight * 0.9 + 'px',
        width: this.lineHeight * 0.9 + 'px',
        borderWidth: borderWidth + 'px',
        lineHeight: lh + 'px',
      };
    },
    lineHeightChange() {
      let paddingBotton = Number(
        window
          .getComputedStyle(document.querySelector('.dashboard'), null)
          .paddingBottom.replace('px', '')
      );
      let innerHeight =
        window.innerHeight -
        document.querySelector('.table-title').getBoundingClientRect().bottom -
        paddingBotton;
      // let gap = Number(window.getComputedStyle(document.querySelector('.dashboard'), null).gridRowGap.replace('px', ''));
      let lh = innerHeight / this.users.length;
      let newGap = lh * 0.1; //10% от высоты будут занимать отступы
      this.lineHeight = lh < 140 ? lh * 0.9 : 140; //.9 потому что 90%
      this.gap = { gridRowGap: newGap + 'px' };
    },
    async renew() {
      console.log('renew');
      const columnsPromise = this.post('getColumns', {
        panelId: this.panelId,
        password: this.password,
      });
      const callsSettingsPromise = this.post('getCallsSettings', {
        panelId: this.panelId,
        password: this.password,
      });
      const zoomSettingsPromise = this.post('getZoomSettings', {
        panelId: this.panelId,
        password: this.password,
      });

      const dataPromise = this.post('getData', {
        panelId: this.panelId,
        password: this.password,
      });

      const callsPromise = this.post('getCalls', {
        panelId: this.panelId,
        password: this.password,
      });

      this.columns = await columnsPromise;
      this.data = await dataPromise;
      this.callsSettings = await callsSettingsPromise;
      this.zoomSettings = await zoomSettingsPromise;
      this.calls = await callsPromise;

      await this.calculateNorma();

      let users = this.data.reduce((users, u) => {
        const callsInfo = this.findUserCalls(u);
        let callsPercent = Math.round(
          (callsInfo.calls / this.expectedCalls) * 100
        );
        if (callsPercent > 100) callsPercent = 100;

        let minutesPercent = Math.round(
          (callsInfo.minutes / this.expectedMinutes) * 100
        );
        if (minutesPercent > 100) minutesPercent = 100;

        const user = {
          ...u,
          id: u.key,
          name: u.name,
          callPercent: this.expectedCalls ? callsPercent : 0,
          calls: callsInfo.calls,
          minutePercent: this.expectedMinutes ? minutesPercent : 0,
          minutes: callsInfo.minutes,
          columns: u,
        };

        users.push(user);
        return users;
      }, []);

      users = this.getPlaceBy(users, 'calls');
      users = this.getPlaceBy(users, 'minutes');
      for (const column of this.columns){
        users = this.getPlaceBy(users, column._id);
      }

      const summedUsers = users.map(user => {
        // console.log(user.rates)
        user.places = _.reduce(user.rates, (acc, value) => {
         // console.log({acc, value})
          acc = acc+value
          return acc
        })
        return user
      })


      const placeSumSort = R.sortWith([
        R.ascend(R.prop('places')),
        R.ascend(R.prop('name'))
      ]);

      this.users = placeSumSort(summedUsers).reduce((acc, u) => {
        if (!acc.length) {
          acc.push({...u, leader: true})
        } else {
          if (u.places === acc[0].places) {
            acc.push({...u, leader: true})
          } else {
            acc.push(u)
          }
        }
        return acc
      },[]).slice(this.offset, this.offset+this.limit)

      
    },
    mapUsers(users) {
      for (const u of users) {
        console.log(u.name)
      }
    },
    getPlaceBy (users, param) {
      return _.sortBy(users, [function(o) { 
        switch (param) {
          case 'calls':
            return o.calls
          case 'minutes':
            return o.minutes
          default: 
            return o.columns[param]
        }
         }])
        .reverse()
        .map((user) => {
          if (!user.rates) user.rates = {};
          if (!user.rating) user.rating = 0
          return user;
        })
        .reduce((users, user, index) => {
          if (index === 0) {
            user.place = 1;
          } else {
            const lastuser = users[users.length - 1];
            if (user[param] === lastuser[param]) {
              user.place = lastuser.place;
            } else {
              user.place = lastuser.place + 1;
            }
          }
          users.push(user);
          return users;
        }, [])
      .map((user) => {
          user.rates[param] = Number(user.place)
          delete user.place;
          return user
        });
    },
  },
  computed: {
    colstyle() {
      let style;

      const columns = this.columns.length + 1;
      if (document.getElementsByTagName('body')[0].clientWidth > 1600) {
        style = {
          'grid-template-columns': `337px repeat(${columns}, 1fr) 248px`,
        };
      } else {
        style = {
          'grid-template-columns': `254px repeat(${columns}, auto) 1fr`,
        };
      }
      if (this.gap) {
        style = { ...style, ...this.gap };
      } else {
        style = { ...style, gridRowGap: '60px' };
      }

      style = {...style, zoom: this.zoomSettings.zoom || 1}
      return style;
    },
    part_of_day() {
      if (!this.callsSettings.daystart) return 0;
      const startTimeArray = this.callsSettings.daystart.split(':');
      const endTimeArray = this.callsSettings.dayend.split(':');

      let now_minutes = moment()
        .tz('Europe/Moscow')
        .diff(
          moment()
            .tz('Europe/Moscow')
            .startOf('day'),
          'minutes'
        );
      const start_minutes = moment()
        .tz('Europe/Moscow')
        .set({ hour: startTimeArray[0], minutes: startTimeArray[1] })
        .diff(
          moment()
            .tz('Europe/Moscow')
            .startOf('day'),
          'minutes'
        );
      const end_minutes = moment()
        .tz('Europe/Moscow')
        .set({ hour: endTimeArray[0], minutes: endTimeArray[1] })
        .diff(
          moment()
            .tz('Europe/Moscow')
            .startOf('day'),
          'minutes'
        );

      const dayLength = end_minutes - start_minutes;

      if (now_minutes < start_minutes) now_minutes = start_minutes;
      if (now_minutes > end_minutes) now_minutes = end_minutes;

      const minutesFromStart = now_minutes - start_minutes;

      let part_of_day = minutesFromStart / dayLength;

      return part_of_day;
    },
    expectedCalls() {
      return parseInt(Math.floor(this.callsSettings.calls * this.part_of_day));
    },
    expectedMinutes() {
      return parseInt(
        Math.floor(this.callsSettings.minutes * this.part_of_day)
      );
    },
    grid() {
      if (window.innerWidth > 1600) {
        return { gridTemplateColumns: '' };
      }
      return { gridTemplateColumns: '' };
    },
  },
  watch: {
    users: 'lineHeightChange',
  },
  mounted() {
    this.post = bent(this.baseUrl, 'POST', 'json', 200);
    document.title = 'Panel - SimpleSales';
    const urlParams = new URLSearchParams(window.location.search);
    this.limit = urlParams.get('limit') ? Number(urlParams.get('limit')) : 100;
    this.offset = urlParams.get('offset') ? Number(urlParams.get('offset')) : 0;
    this.lineHeightChange();
    this.renew();
    this.interval = setInterval(this.renew, 10000);
  },
  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped lang="sass">

.dashboard
  margin: 0 auto
  padding: 50px 70px
  display: grid
  // Следующие 2 строки, это отступы по вертикали и горизонтали
  row-gap: 60px
  column-gap: 60px
  align-items: center
  justify-content: center
  color: white
  @media (max-width: 1350px)
    padding: 40px 50px
    row-gap: 50px
    column-gap: 50px
  @media (min-width: 1800px)
    gap: 70px 100px
    row-gap: 100px
    column-gap: 70px
  > *
    margin: 0 auto


.logo
  height: 45px
  margin-left: 0
  img
    height: 45px

h3
  font-size: 24.5px
  font-family: evolventa,sans-serif
  font-weight: 700
  color: #fff
  margin: 0
  span
    color: #12C3FF
    font-size: 17px
    font-weight: normal

h2
  font-size: 32px
  margin: 0
  font-weight: 700
  color: #fff

.proceeds
  margin-right: 0

.username
  margin-left: 0
  font-weight: normal
  letter-spacing: .07em
  align-self: flex-end
  line-height: 1.1
  font-size: 28px
  white-space: pre

.table-title
  white-space: nowrap
  line-height: .9

.round-info
  display: flex
  justify-content: center
  align-items: center
  height: 125px
  width: 125px
  line-height: 115px
  border-radius: 50%
  border: 5px solid #494F6B
  font-size: 43px
  font-weight: bold
  vertical-align: center

.big-number
  font-size: 43px
  font-family: evolventa,sans-serif
  font-weight: bold
  justify-self: flex-end
  text-align: right
  margin-right: 0

.bold
  font-weight: bold
</style>
